// extracted by mini-css-extract-plugin
export default {"searchTermCard":"RecentSearches_searchTermCard__i0X2W","searchTermText":"RecentSearches_searchTermText__TeqLh","resultIcon":"RecentSearches_resultIcon__t1YZX"};